import Toastify from 'toastify-js';

class ProductFilesModal {
    constructor() {
        this.lpm = $("#login-modal");
        this.loginPopup = $("#login-popup");
        const self = this;

        $ = jQuery;

        $(function () {
            self.modal();
        });

        $(function () {
            if (self.loginPopup) {

                self.loginPopup.show();
            }
        });
    }



    modal() {

        const self = this;
        this.lpm.on("hidden.bs.modal", function (e) {
            $(".adc-status").remove();
        });

        $(document).on("click", "#login-popup a", function (e) {
            e.preventDefault();
        });

        $(document).on("click", "#login-popup", function (e) {
            e.preventDefault();

            $('.modal-body-login #wp-submit').addClass('btn btn-primary inline-arrow');
            // Open the modal
            self.lpm.modal("show");
        });
    }

}

jQuery("#loginform").on('submit', function (e) {
    e.preventDefault();

    var formData = $(this).serialize();
    $('.modal-body-login #wp-submit').addClass('disabled');
    $.ajax({
        type: "POST",
        dataType: 'json',
        url: ajax.url,
        data: "action=custom_login&" + formData,
        success: function (response) {
            $('.modal-body-login #wp-submit').removeClass('disabled');
            if (response.status) {
                location.reload();
            } else {
                Toastify({
                    text: ajax.lang_str.product.wrong_user_or_pass,
                    duration: 5000,
                    escapeMarkup: false,
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "center",
                    stopOnFocus: true,
                    style: {
                        background: "#B33A3A"
                    }
                }).showToast();
            }
        }
    });
});


export default ProductFilesModal;
